(function () {

  /* ===============================
     PAGE CHECK
  =============================== */

  if (!document.body.className.includes('template-suffix-build-your-bundle')) return;


  /* ===============================
     GLOBAL STATE
  =============================== */

  const bundle = {
    max: 0,
    discount: 0,
    items: {} // variantId → qty
  };

  /* ===============================
     HELPERS
  =============================== */


  const totalItems = () =>
    Object.values(bundle.items).reduce((a, b) => a + b, 0);

  const discounted = price =>
  Math.round(price * (100 - bundle.discount) / 100);

  
  function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
  }


  /* ===============================
     INITIAL DEFAULT SELECTION
  =============================== */

    document.addEventListener('DOMContentLoaded', () => {
    const active = document.querySelector('.bundle-option.active');
    if (!active) return;

    document.dispatchEvent(
        new CustomEvent('bundle:change', {
        detail: {
            quantity: Number(active.dataset.quantity),
            discount: Number(active.dataset.discount)
        }
        })
    );
    });

  /* ===============================
     BUNDLE SIZE SELECTOR
  =============================== */

  document.addEventListener('click', e => {
    const btn = e.target.closest('.bundle-option');
    if (!btn) return;

    const group = btn.closest('.bundle-options');
    group.querySelectorAll('.bundle-option').forEach(b =>
      b.classList.remove('active')
    );

    btn.classList.add('active');

    document.dispatchEvent(
      new CustomEvent('bundle:change', {
        detail: {
          quantity: Number(btn.dataset.quantity),
          discount: Number(btn.dataset.discount)
        }
      })
    );
  });

  /* ===============================
     BUNDLE CHANGE HANDLER
  =============================== */

  document.addEventListener('bundle:change', e => {

    bundle.max = Number(e.detail.quantity);
    bundle.discount = Number(e.detail.discount);

    bundle.items = {};

    document.querySelectorAll('.bundler__product__quantity').forEach(el => {
      el.innerText = 0;
      el.dataset.quantity = 0;
    });

    document.querySelectorAll('.bundler__product__minus').forEach(btn => {
      btn.disabled = true;
    });

    updatePrices();
    updateFooter();
    enforceLimits();
  });

  /* ===============================
     PRODUCT +/- HANDLING
  =============================== */

  document.addEventListener('click', e => {

    const plus = e.target.closest('.bundler__product__plus');
    const minus = e.target.closest('.bundler__product__minus');

    if (!plus && !minus) return;

    if (!bundle.max) {
      alert('Please select a bundle size first');
      return;
    }

    const card = e.target.closest('.product-block')
      ?.querySelector('.bundle-product-card');

    if (!card) return;

    const id = card.dataset.variantId;

    bundle.items[id] = bundle.items[id] || 0;

    if (plus && totalItems() < bundle.max) {
      bundle.items[id]++;
    }

    if (minus) {
      bundle.items[id]--;
      if (bundle.items[id] <= 0) delete bundle.items[id];
    }

    const qty = bundle.items[id] || 0;

    const qtyEl = card.querySelector('.bundler__product__quantity');
    const minusBtn = card.querySelector('.bundler__product__minus');

    qtyEl.innerText = qty;
    qtyEl.dataset.quantity = qty;
    minusBtn.disabled = qty === 0;

    updateFooter();
    enforceLimits();
  });

  /* ===============================
     PRODUCT PRICE UPDATE
  =============================== */

    function updatePrices() {

    document.querySelectorAll('.product-block').forEach(block => {

      const bundleCard = block.querySelector('.bundle-product-card');
      if (!bundleCard) return;

      const price = Number(bundleCard.dataset.price);

      const compare = block.querySelector('.compare-price');
      const discountEl = block.querySelector('.discounted-price');

      if (!compare || !discountEl) return;

      if (bundle.discount > 0) {

        compare.style.textDecoration = 'line-through';
        compare.style.display = 'inline-block';

        discountEl.textContent = formatMoney(discounted(price));
        discountEl.style.display = 'inline-block';

      } else {

        compare.style.textDecoration = 'none';
        discountEl.style.display = 'none';

      }
    });
  }


  /* ===============================
     LIMIT ENFORCEMENT
  =============================== */

  function enforceLimits() {

    const reached = totalItems() >= bundle.max;

    document.querySelectorAll('.bundle-product-card').forEach(card => {

      const id = card.dataset.variantId;
      const qty = bundle.items[id] || 0;
      const plus = card.querySelector('.bundler__product__plus');

      if (reached && qty === 0) {
        plus.disabled = true;
      } else {
        plus.disabled = false;
      }
    });
  }

  /* ===============================
     FOOTER UPDATE
  =============================== */

  function updateFooter() {

    const footer = document.querySelector('.bundle-cart-footer');
    if (!footer) return;

    let total = 0;

    for (const id in bundle.items) {
      const card = document.querySelector(
        `.bundle-product-card[data-variant-id="${id}"]`
      );
      if (!card) continue;

      total += bundle.items[id] * Number(card.dataset.price);
    }

    const count = totalItems();
    const remaining = bundle.max - count;

    const cartBtnWrapper = footer.querySelector('.cart-button-container');

    if (remaining === 0) {
    cartBtnWrapper.style.display = 'block';
    } else {
    cartBtnWrapper.style.display = 'none';
    }

    document.getElementById('bundle-count-number').innerText = count;

    const emptyState = footer.querySelector('.empty-bundle-cart');
    const filledState = footer.querySelector('.quantity-bundle-cart');

    if (count === 0) {
      emptyState.classList.add('_show');
      emptyState.classList.remove('_hide');
      filledState.classList.add('_hide');
      filledState.classList.remove('_show');
      return;
    }

    emptyState.classList.remove('_show');
    emptyState.classList.add('_hide');
    filledState.classList.remove('_hide');
    filledState.classList.add('_show');

    const oldEl = footer.querySelector('.bundle-price__regular');
    const newEl = footer.querySelector('.bundle-price__sale');




    oldEl.textContent = formatMoney(total);
    newEl.textContent = formatMoney(discounted(total));




    if (bundle.discount > 0) {
    oldEl.textContent = formatMoney(total);
    oldEl.style.display = 'inline-block';

    newEl.textContent = formatMoney(discounted(total));
    newEl.style.display = 'inline-block';
    } else {
    oldEl.innerText = '';
    oldEl.style.display = 'none';

    newEl.textContent = formatMoney(discounted(total));
    newEl.style.display = 'inline-block';
    }

    const remainingNode = document.getElementById('bundle-remaining-text');
    if (remainingNode) {
      remainingNode.innerText =
        remaining > 0
          ? `Please select ${remaining} more item${remaining > 1 ? 's' : ''}`
          : '';
    }

    const remainingNodeMobile = document.getElementById('bundle-remaining-text-mobile');
    if (remainingNodeMobile) {
      remainingNodeMobile.innerText =
        remaining > 0
          ? `Please select ${remaining} more item${remaining > 1 ? 's' : ''}`
          : '';
    }




  }

  /* ===============================
     ADD BUNDLE TO CART
  =============================== */

  const addBtn = document.getElementById('add-bundle-cart');

  if (addBtn) {
    addBtn.addEventListener('click', async () => {

      if (totalItems() !== bundle.max) {
        alert('Please complete your bundle');
        return;
      }

      // 🔒 prevent multiple clicks
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      const originalText = addBtn.innerText;
      addBtn.innerText = 'Adding…';

      const items = [];

      for (const id in bundle.items) {
        items.push({
          id: Number(id),
          quantity: bundle.items[id],
          properties: {
            Bundle: `${bundle.max} pairs – ${bundle.discount}% OFF`
          }
        });
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (res.ok) {

          if (typeof monster_refresh === 'function') {
            monster_refresh(true);
          }

        }

      } catch (err) {
        console.error('Bundle add failed', err);
        alert('Something went wrong. Please try again.');
      }

      // 🔓 safety fallback (in case drawer fails)
      setTimeout(() => {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        addBtn.innerText = originalText;
      }, 3000);

    });
}





/* ===============================
   AUTO LOAD MORE (SCROLL + BUTTON)
================================ */

const bundleGrid = document.getElementById('bundle-grid');
const loadMoreBtn = document.getElementById('bundle-load-more');

if (bundleGrid && loadMoreBtn) {

  let isLoading = false;

  const updateButtonVisibility = () => {
    const nextUrl = bundleGrid.dataset.nextUrl;
    loadMoreBtn.style.display = nextUrl ? 'block' : 'none';
  };

  const loadNextPage = async () => {
    const nextUrl = bundleGrid.dataset.nextUrl;
    if (!nextUrl || isLoading) return;

    isLoading = true;
    loadMoreBtn.disabled = true;
    loadMoreBtn.innerText = 'Loading...';

    try {
      const res = await fetch(nextUrl);
      const htmlText = await res.text();

      const temp = document.createElement('div');
      temp.innerHTML = htmlText;

      const newGrid = temp.querySelector('#bundle-grid');
      const newItems = newGrid?.children || [];

      [...newItems].forEach(item => {
        bundleGrid.appendChild(item);
      });


      updatePrices();
      enforceLimits();

      bundleGrid.dataset.nextUrl =
        newGrid?.dataset.nextUrl || '';

    } catch (err) {
      console.error('Bundle load more failed', err);
    }

    isLoading = false;
    loadMoreBtn.disabled = false;
    loadMoreBtn.innerText = 'Load more';

    updateButtonVisibility();
  };

  /* BUTTON CLICK FALLBACK */
  loadMoreBtn.addEventListener('click', loadNextPage);

  /* AUTO LOAD ON SCROLL */
  const observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting) {
        loadNextPage();
      }
    },
    {
      rootMargin: '200px',
    }
  );

  observer.observe(loadMoreBtn);

  updateButtonVisibility();
}










})();
